function formatDate(now,centre='-',num=0) {
    if((now+'').length==10){
        var d=new Date(now*1000);////时间戳为10位需*1000，时间戳为13位的话不需乘1000
    }else{
       var d=new Date(now);////时间戳为10位需*1000，时间戳为13位的话不需乘1000 
    }
   var year=d.getFullYear(); 
   var month=d.getMonth()+1<10?'0'+(d.getMonth()+1):d.getMonth()+1; 
   var date=d.getDate()<10?'0'+d.getDate():d.getDate(); 
   var hour=d.getHours(); 
   var minute=d.getMinutes()<10?'0'+d.getMinutes():d.getMinutes(); 
   var second=d.getSeconds()<10?'0'+d.getSeconds():d.getSeconds(); 
   if(num==0){
       return year+centre+month+centre+date+' '+hour+':'+minute+":"+second; //后面需要添加小时，分钟，秒数，随时可以添加
   }else if(num==1){
       return month+'月'+date+'日 '+hour+':'+minute;
   }
   
}
export default formatDate


// WEBPACK FOOTER //
// ./src/time.js